export const Colors = {

    WHITE: "#FFFFFF",
    BLUE_ROW_TABLE: "aliceblue",
    GRAY_LOW: "#f7f7fa",
    BLUE_LOW: "#eef5fc",
    GREEN_SWITCH_ACTIVE: "#52D869",
    RED_SWITCH_INACTIVE: "#E53935",
    CARD_MENUS: "lightgoldenrodyellow",
    COLOR_AMOVIL_BLUE_DARK: "#001B53",
    COLOR_GREEN_DARK: "#008000",
    COLOR_BLUE_THEME: "#308EFF",
    COLOR_BLUE_DARK_LABEL_INPUT: "#3F51B5",
    DARK_GRAY: "gray",
    COLOR_SKY_THEME: "#37A6DE",
    AZUL_CLARO_RGBA: "rgba(48, 142, 255, .5)",
    ORANGE: "#FF8000",
    ORANGE_DARK: "#F44611",
    ROJO_PASTEL: "#FF6961",
    VERDE_AGUA_MARINA: "#00b0c7",
    AMARILLO_MOSTAZA: "#f39c16",
    MORADO: "#6632ff",
    GRIS_CLARO: "#DEDEEC",
    GREEN_TEXT: "#64DF38",

    //* COLOR CELDA TABLA
    COLOR_CELL_SUCCESS: "#D8F5E2",
    COLOR_CELL_ERROR: "#FAEDE6",
    COLOR_CELL_BLUE: "#D9E1F2",

    COLOR_BACKGROUND_TABLE: "#EBEBEB",
    COLOR_TEXT_TABLE: "#404040"
}
